module.exports = __webpack_public_path__ + "img/rehan.a1e4cb1b.jpeg";